// Snapshot comparison columns: figures captured from a computed case (saved with the case in appData.disOS).
// NB: these "snapshots" are read-only figure captures for the compare report — distinct from a Scenario
// (an editable version of a case) in the client/scenario versioning model.
import type { Case, CaseResult } from '@divorceos/schema';
import { timeshareWith } from '../lib/children';
import { appliedFc4055, signed, ssName } from './model';
import type { ScenarioFigures } from './appData';

export function snapshotFigures(c: Case, r: CaseResult): ScenarioFigures {
  const g = r.guideline;
  return {
    year: c.taxYear,
    ssMethod: ssName(c.settings.ssMethod),
    fc4055: appliedFc4055(c) === 'SB343' ? 'From 9/1/2024' : 'Before 9/1/2024',
    ts: timeshareWith(c.children, 0),
    net: [r.parties[0].netDisposable, r.parties[1].netDisposable],
    cs: Math.abs(signed(g.basicCs)),
    addOns: Math.abs(signed(g.addOns)),
    ss: Math.abs(signed(g.ss)),
    total: g.total.amount,
    payor: g.total.payor,
    ns: [r.parties[0].guideline.netSpendable, r.parties[1].guideline.netSpendable],
    ptotal: Math.abs(r.proposed.total),
    psaving: r.proposed.saving,
  };
}

/** Proposed-column figures in the same shape (for the live "Proposed" column). */
export function proposedFigures(c: Case, r: CaseResult): ScenarioFigures {
  const base = snapshotFigures(c, r);
  const p = r.proposed;
  return { ...base, cs: p.nondeductible.amount, ss: p.deductible.amount, addOns: p.addOns.amount, total: Math.abs(p.total), payor: p.nondeductible.payor ?? p.deductible.payor, ns: [r.parties[0].proposed.netSpendable, r.parties[1].proposed.netSpendable] };
}
